import { Link } from "react-router-dom";
import { Dumbbell } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 font-extrabold">
            <span className="w-8 h-8 rounded-lg bg-slate-900 text-white grid place-items-center">
              <Dumbbell className="w-4 h-4" />
            </span>
            TymCoach
          </div>
          <p className="mt-3 text-sm text-slate-600 max-w-xs">
            La plateforme qui transforme les créneaux libres des salles en opportunités pour coachs et particuliers.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase font-semibold text-slate-500 tracking-wider">Explorer</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            <li><Link to="/carte" className="hover:text-slate-900">Carte & Salles</Link></li>
            <li><Link to="/coachs" className="hover:text-slate-900">Coachs disponibles</Link></li>
            <li><Link to="/comment-ca-marche" className="hover:text-slate-900">Comment ça marche</Link></li>
            <li className="flex gap-2 flex-wrap">{["paris", "lyon", "bordeaux"].map((c) => <Link key={c} data-testid={`footer-city-${c}`} to={`/salles-de-sport/${c}`} className="hover:text-slate-900 capitalize">{c}</Link>)}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase font-semibold text-slate-500 tracking-wider">Compte</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            <li><Link to="/inscription" className="hover:text-slate-900">Créer un compte</Link></li>
            <li><Link to="/connexion" className="hover:text-slate-900">Se connecter</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-4 text-xs text-slate-500 flex flex-wrap gap-x-4 gap-y-1 items-center">
        <span>© 2026 TymCoach — Fait avec passion en France.</span>
        <Link data-testid="footer-cgu" to="/legal/cgu" className="hover:text-slate-900 underline">CGU</Link>
        <Link data-testid="footer-confidentialite" to="/legal/confidentialite" className="hover:text-slate-900 underline">Confidentialité</Link>
        <Link data-testid="footer-mentions" to="/legal/mentions-legales" className="hover:text-slate-900 underline">Mentions légales</Link>
      </div>
    </footer>
  );
}
